import { Stack, Typography, Link } from '@mui/material';
import { useState } from 'react';

import StyledTextField from '../../components/TextField';
import Button from '../../components/styledComponents/Button';
import getAndSetLocalAuthCookies from '../../utils/getAndSetLocalAuthCookies';

export default function LocalSetNewToken() {
  const [translatorUrl, setTranslatorUrl] = useState<string>('');
  const [loading, setLoading] = useState(false);

  const stripDomainFromTranslatorUrl = translatorUrl?.split(
    'csaa-insurance.aaa.com'
  )[1];

  return (
    <Stack sx={{ minWidth: 1, p: 5 }} spacing={2} component="form">
      <Typography>
        Please enter a Translator Service URL to be used for your session.{' '}
        <Link
          target="_blank"
          rel="noreferrer"
          href="https://csaaig.atlassian.net/wiki/spaces/MYP2/pages/2835711418/MyPolicy+2.0+Test+Data+Repository"
        >
          Please see this confluence document for the current list of test urls.
        </Link>
      </Typography>
      <StyledTextField
        label="Please enter a translator service url:"
        value={translatorUrl}
        onChange={(e) => setTranslatorUrl(e.target.value)}
        data-testid="translator-link-field"
      />
      <Button
        variant="contained"
        disableElevation
        sx={{
          textTransform: 'none',
          height: 42,
          width: 'auto',
          fontSize: { mobile: 16, tablet: 18 },
          py: { mobile: 1 },
          px: [null, 4, 4],
          borderWidth: 2,
          fontWeight: 700,
          alignSelf: 'flex-end',
        }}
        onClick={() =>
          getAndSetLocalAuthCookies(stripDomainFromTranslatorUrl, setLoading)
        }
        loading={loading}
        data-testid="redirect-to-mpr-button"
      >
        Refresh session with new token
      </Button>
    </Stack>
  );
}
